import { Suspense, useEffect, useState } from 'react'
import {
    Await,
    defer,
    Link,
    useLoaderData
} from 'react-router-dom'
import { event } from '../util/api'
import Heading from './helper/Heading'
import Iframe from './helper/Iframe'
import LoadingSpinner from './components/LoadingSpinner'
import { Title } from './helper/DocumentTitle'
import styles from '../styles/module/TourDetails.module.scss'

export const loader = async ({ params }) => {
    console.log(params.id)
    return defer({ vr: event(params.id) })
}

export default function TourDetails() {
    const [loaderData, setLoaderData] = useState(useLoaderData())

    const estimateDay = (date) => Math.floor((new Date(date).getTime() - new Date().getTime()) / (1000 * 60 * 60 * 24));

    useEffect(() => {
        document.querySelector('header span').innerText = 'رویدادهای مهم'
    }, [])

    return (
        <section className={styles.vr}>
            <div className='__frame' data-width={`large`}>
                <Suspense fallback={<LoadingSpinner />}>
                    <Await
                        resolve={loaderData.vr}
                        errorElement={<>error</>}>
                        {(data) => {
                            console.log(data)
                            return (
                                data.map((item) => {
                                    Title(item.title)
                                    return <>
                                        <Heading name={item.title}/>
                                        <img src={`${process.env.REACT_APP_UPLOAD}images/${item.img}`} className='' style={{
                                            width: '200px', margin: '0 auto', border:'2px solid #eee',borderRadius:'8px'
                                        }} />
                                        <p>{item.description}</p>
                                        <Heading name='تعداد روزهای باقی مانده به رویداد'/>
                                        <h2 style={{background:'var(--warning)', textAlign:'center'}}>{estimateDay(item.at)}</h2>
                                    </>
                                })
                            )
                        }}
                    </Await>
                </Suspense>
            </div>
        </section>
    )
}